import { Menu } from 'antd';
import { FieldTimeOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons';
import React, { Component } from 'react';
import t from '../i18n'

const { SubMenu } = Menu;

class App extends React.Component {
  state = {
    current: this.props.current || 'current_stock',
  };

  handleClick = e => {
    console.log('click ', e);
    this.setState({ current: e.key });
  };

  render() {
    const { current } = this.state;
    return (
      <Menu onClick={this.handleClick} selectedKeys={[current]} mode="horizontal">

        <Menu.Item key="current_stock" icon={<FieldTimeOutlined />}>
          <a href="/reports/stock" >
            {t('current_stock')}
          </a>
        </Menu.Item>

        <Menu.Item key="stock_movements" icon={<FieldTimeOutlined />}>
          <a href="/reports/stock/movements" >
            {t('stock_movements')}
          </a>
        </Menu.Item>

        <Menu.Item key="low_stock" icon={<FieldTimeOutlined />}>
          <a href="/reports/stock/low" >
            {t('low_stock')}
          </a>
        </Menu.Item>

        <Menu.Item key="backordered" icon={<FieldTimeOutlined />}>
          <a href="/reports/stock/backordered" >
            {t('failure_list')}
          </a>
        </Menu.Item>

        <Menu.Item key="ageing" icon={<FieldTimeOutlined />}>
          <a href="/reports/stock/agening" >
            {t('ageing_stock')}
          </a>
        </Menu.Item>

        {/* <Menu.Item key="sales" icon={<FieldTimeOutlined />}>
          <a href="/reports/stock/sales" >
            Sales 
          </a>
        </Menu.Item> */}

      </Menu>
    );
  }
}
export default App;
